import Header from '../ui/Header';
import { useTranslation, Trans } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import History from '../history/History';
import { useState, useEffect } from 'react';
import { getOldestIndexDate } from '../../utils/timestampHelper';
import { getIndexTimestamp } from '../../services/indexTimestamp';
import { useAuth } from '../../hooks/useAuth';

const formatLastUpdated = (date) =>
	date.toLocaleString('sv-SE', {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
	});

const QueryLayout = () => {
	const { t } = useTranslation();
	const { token } = useAuth();
	const [lastUpdated, setLastUpdated] = useState(null);

	useEffect(() => {
		if (!token) return;

		let ignore = false;
		setLastUpdated(null);

		getIndexTimestamp(token)
			.then(getOldestIndexDate)
			.catch(() => null)
			.then((date) => {
				if (ignore) return;
				setLastUpdated(date ? formatLastUpdated(date) : t('footer.timestamp_unavailable'));
			});

		return () => {
			ignore = true;
		};
	}, [token, t]);

	return (
		<div className='flex flex-col min-h-screen'>
			<Header />
			<div className='flex flex-1'>
				<div className='border-r border-tertiary bg-white'>
					<History />
				</div>
				<div className='flex flex-col flex-1'>
					<div className='flex justify-center flex-1'>
						<Outlet />
					</div>

					<div className='flex justify-center items-center p-20'>
						<span className='text-on-tertiary-active text-center text-sm font-medium'>
							{lastUpdated && (
								<Trans
									i18nKey={'footer.notice_timestamp'}
									components={{ br: <br /> }}
									values={{
										app_name: t('general.app_name'),
										timestamp: lastUpdated,
									}}
								/>
							)}
							{!lastUpdated && (
								<Trans
									i18nKey='footer.notice'
									components={{ br: <br /> }}
									values={{
										app_name: t('general.app_name'),
									}}
								/>
							)}
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default QueryLayout;
